/**
 * Retourne vrai si les paramètres minimum pour l'estimation
 *   d'une réservation sont présents.
 * @param {object} param0
 * @param {object} parameterList, liste des paramètres à tester
 * @return {boolean}
 */
export default function mayEstimate({ parameterList }) {
  if ("" === (parameterList?.adults ?? "")) {
    return false;
  }

  if ("" === (parameterList?.checkin ?? "")) {
    return false;
  }

  if ("" === (parameterList?.checkout ?? "")) {
    return false;
  }

  if ("" === (parameterList?.roomReference ?? "")) {
    return false;
  }

  if ((parameterList?.checkin ?? "") === (parameterList?.checkout ?? "")) {
    return false;
  }

  return true;
}
